import React, { Component } from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/errors/NotFound";
import { SkeletonPage } from "./components/mellro-primitives/SkeletonLoader";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";
// layouts
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import OldApp from "./components/OldApp";

// PrimeReact CSS — carregado antes do theme para nossos overrides vencerem a cascade
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primeicons/primeicons.css";

// Import scss — deve vir APÓS o PrimeReact para que _primereact.scss sobrescreva o tema
import "./theme.scss";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getLayout = this.getLayout.bind(this);
    }

    /**
   * Returns the layout
   */
    getLayout = () => {
        let layoutCls = VerticalLayout;
        switch (this.props.layout.layoutType) {
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };

    render() {
        const Layout = this.getLayout();

        return (
            <React.Fragment>
                <Router>
                    <ErrorBoundary label="Não foi possível carregar a página. Tente recarregar.">
                    <React.Suspense fallback={
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'var(--ui-bg-light)',
                            zIndex: 9999,
                            padding: '80px 24px 0',
                        }}>
                            <SkeletonPage rows={6} />
                        </div>
                    }>
                        <Switch>
                            <Route path="/old" component={OldApp} />

                            {publicRoutes.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    layout={NonAuthLayout}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={false}
                                />
                            ))}

                            {authProtectedRoutes.map((route, idx) => (
                                <AppRoute
                                    path={route.path}
                                    exact={route.exact}
                                    layout={Layout}
                                    component={route.component}
                                    key={idx}
                                    isAuthProtected={true}
                                />
                            ))}

                            <AppRoute
                                layout={Layout}
                                component={NotFound}
                                isAuthProtected={true}
                            />
                        </Switch>
                    </React.Suspense>
                    </ErrorBoundary>
                </Router>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        layout: state.Layout
    };
};


export default connect(mapStateToProps, null)(App);
